/* Reviewed static content-page interface translations. */
export const GENERATED_CONTENT_UI: Record<string, Record<string, string>> = {
  zh: {
    home: '首页',
    guides: 'IQ 指南',
    reviewed: '已审核',
    evidence: '包含证据和局限说明',
    onThisPage: '本页内容',
    faq: '常见问题',
    commonQuestions: '常见问题',
    references: '参考资料',
    sourcesTitle: '资料来源与延伸阅读',
    importantContext: '重要说明',
    disclaimer:
      'IQLabTest 提供教育内容和参考性在线评估，并非临床诊断或官方标准化 IQ 证明。如需依据结果作出决定，请咨询合格专业人士。',
    continueLearning: '继续学习',
    relatedGuides: '相关 IQ 指南',
    readGuide: '阅读指南',
    knowledgeCenter: 'IQ 知识中心',
    indexTitle: '理性了解认知能力',
    indexLead: '以证据为基础的指南，清楚说明不确定性和局限。',
    explore: '浏览',
    ready: '准备好开始了吗？',
    ctaTitle: '探索你的认知优势',
    ctaText: '使用你偏好的语言完成 IQLabTest 结构化 40 题评估。',
    startTest: '开始 IQ 测试',
  },
  hi: {
    home: 'मुखपृष्ठ',
    guides: 'IQ मार्गदर्शिकाएँ',
    reviewed: 'समीक्षा की गई',
    evidence: 'प्रमाण और सीमाएँ शामिल',
    onThisPage: 'इस पृष्ठ पर',
    faq: 'अक्सर पूछे जाने वाले प्रश्न',
    commonQuestions: 'सामान्य प्रश्न',
    references: 'संदर्भ',
    sourcesTitle: 'स्रोत और आगे पढ़ें',
    importantContext: 'महत्वपूर्ण संदर्भ',
    disclaimer:
      'IQLabTest शैक्षिक सामग्री और एक संकेतात्मक ऑनलाइन आकलन प्रदान करता है; यह नैदानिक निदान या आधिकारिक मानकीकृत IQ प्रमाणपत्र नहीं है। परिणाम पर कोई निर्णय निर्भर हो तो योग्य पेशेवर से सलाह लें।',
    continueLearning: 'सीखना जारी रखें',
    relatedGuides: 'संबंधित IQ मार्गदर्शिकाएँ',
    readGuide: 'मार्गदर्शिका पढ़ें',
    knowledgeCenter: 'IQ ज्ञान केंद्र',
    indexTitle: 'बिना अतिशयोक्ति के संज्ञान को समझें',
    indexLead: 'प्रमाण-आधारित मार्गदर्शिकाएँ जो अनिश्चितता और सीमाएँ स्पष्ट करती हैं।',
    explore: 'देखें',
    ready: 'शुरू करने के लिए तैयार हैं?',
    ctaTitle: 'अपनी संज्ञानात्मक क्षमताओं को जानें',
    ctaText: 'अपनी पसंदीदा भाषा में IQLabTest का संरचित 40-प्रश्न आकलन पूरा करें।',
    startTest: 'IQ परीक्षण शुरू करें',
  },
  fr: {
    home: 'Accueil',
    guides: 'Guides sur le QI',
    reviewed: 'Révisé',
    evidence: 'Preuves et limites incluses',
    onThisPage: 'Sur cette page',
    faq: 'Questions fréquentes',
    commonQuestions: 'Questions courantes',
    references: 'Références',
    sourcesTitle: 'Sources et lectures complémentaires',
    importantContext: 'Contexte important',
    disclaimer:
      'IQLabTest fournit du contenu éducatif et une évaluation indicative en ligne, et non un diagnostic clinique ou un justificatif officiel de QI standardisé. Consultez un professionnel qualifié lorsque la décision dépend du résultat.',
    continueLearning: 'Continuer à apprendre',
    relatedGuides: 'Guides sur le QI associés',
    readGuide: 'Lire le guide',
    knowledgeCenter: 'Centre de connaissances sur le QI',
    indexTitle: 'Comprendre la cognition sans exagération',
    indexLead:
      'Des guides fondés sur les preuves qui rendent visibles les incertitudes et les limites.',
    explore: 'Explorer',
    ready: 'Prêt à commencer ?',
    ctaTitle: 'Explorez vos points forts cognitifs',
    ctaText:
      'Passez une évaluation IQLabTest structurée de 40 questions dans la langue de votre choix.',
    startTest: 'Commencer le test de QI',
  },
  bn: {
    home: 'হোম',
    guides: 'IQ নির্দেশিকা',
    reviewed: 'পর্যালোচিত',
    evidence: 'প্রমাণ ও সীমাবদ্ধতা অন্তর্ভুক্ত',
    onThisPage: 'এই পাতায়',
    faq: 'প্রায়শই জিজ্ঞাসিত প্রশ্ন',
    commonQuestions: 'সাধারণ প্রশ্ন',
    references: 'তথ্যসূত্র',
    sourcesTitle: 'উৎস ও আরও পড়ার উপকরণ',
    importantContext: 'গুরুত্বপূর্ণ প্রেক্ষাপট',
    disclaimer:
      'IQLabTest শিক্ষামূলক বিষয়বস্তু এবং একটি নির্দেশক অনলাইন মূল্যায়ন প্রদান করে; এটি ক্লিনিক্যাল রোগনির্ণয় বা আনুষ্ঠানিক মানসম্মত IQ সনদ নয়। ফলাফলের ওপর কোনো সিদ্ধান্ত নির্ভর করলে যোগ্য পেশাজীবীর পরামর্শ নিন।',
    continueLearning: 'আরও জানুন',
    relatedGuides: 'সম্পর্কিত IQ নির্দেশিকা',
    readGuide: 'নির্দেশিকাটি পড়ুন',
    knowledgeCenter: 'IQ জ্ঞানকেন্দ্র',
    indexTitle: 'অতিরঞ্জন ছাড়াই জ্ঞানীয় ক্ষমতা বুঝুন',
    indexLead: 'প্রমাণভিত্তিক নির্দেশিকা, যেখানে অনিশ্চয়তা ও সীমাবদ্ধতা স্পষ্ট।',
    explore: 'ঘুরে দেখুন',
    ready: 'শুরু করতে প্রস্তুত?',
    ctaTitle: 'আপনার জ্ঞানীয় শক্তি জানুন',
    ctaText: 'আপনার পছন্দের ভাষায় IQLabTest-এর কাঠামোবদ্ধ ৪০-প্রশ্নের মূল্যায়ন দিন।',
    startTest: 'IQ পরীক্ষা শুরু করুন',
  },
};
